export default "__VITE_ASSET__BJOA_lTE__"